
        <div class="dot-navigation" (swipeleft)="swipe($event.type)" (swiperight)="swipe($event.type)">
            <ng-content></ng-content>
        </div>
        <div class="dot-navigation-scroll">
            <span (click)="nextPage(p)" *ngFor="let p of numPages" class="dots" [ngClass]="{'active-dot':page==p}"></span>
        </div>
        